export default __webpack_public_path__ + "static/checklist-9124f3af233b14d7352d02ceac17618d.svg";